import 'lodash';
import jQuery from 'jquery';
window.$ = window.JQuery = jQuery;
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueClipboard from 'vue-clipboard2';

import ReferredUsers from './components/ReferredUsers.vue';
import Share from './components/Share.vue';
import Ambassador from './components/Ambassador.vue';
import AddUser from './components/AddUser.vue';
import AddUserPost from './components/AddUserPost.vue';
import SendReferral from './components/SendReferral.vue';

const APPS = {
  ReferredUsers,
  Share,
  Ambassador,
  AddUser,
  AddUserPost,
  SendReferral
};

Vue.config.devtools = true
Vue.use(VueCookies);
Vue.use(VueClipboard);

function renderAppInElement(el) {
  let App = APPS[el.id];
  if (!App) return;

  // Props as data attributes:
  // <div class="__vue-root" data-message="Hello" id="Greet"></div>
  const props = Object.assign({}, el.dataset);
  new Vue ({
    el,
    render(createElem) {
      return createElem(App, {
        attrs: props
      });
    }
  })
}

document.querySelectorAll('.__vue-root').forEach(renderAppInElement)



// WEBPACK FOOTER //
// ./_vue/index.js